import { gql } from "@apollo/client";

export const DataRiceFragment = gql`
  fragment DataRiceFragment on DataRice {
    formID
    standardName
    formName
    riceTypeName
  }
`;

export const ListFormValuesFragment = gql`
  fragment ListFormValuesFragment on ListFormValues {
    value {
      key
      grainRequire
      isMoreThan
      maxLength
      minLength
      name
      typeUnit
    }
    name
  }
`;

export const RiceFragment = gql`
  fragment RiceFragment on Rice {
    riceID
    riceTypeName
    isBeforeExpired
    expiredDate
    standard {
      imageStandard
      isDefault
      standardID
      standardName
    }
  }
`;

export const typegrainFragment = gql`
  fragment typegrainFragment on typegrain {
    length
    type
    weight
  }
`;

export const outputInspectResultFragment = gql`
  fragment outputInspectResultFragment on outputInspectResult {
    grains {
      ...typegrainFragment
    }
    yellow_pixel
    yellow_kernel
    wholegrain_pixel
    wholegrain_kernel
    undermilled_pixel
    undermilled_kernel
    thinness_pixel
    thinness_kernel
    redwhole_pixel
    redwhole_kernel
    red_pixel
    red_kernel
    paddy_pixel
    paddy_kernel
    head_wholegrain_pixel
    head_wholegrain_kernel
    glutinous_pixel
    glutinous_kernel
    damaged_pixel
    damaged_kernel
    chalky_pixel
    chalky_kernel
    broken_shape_pixel
    broken_shape_kernel
  }
  ${typegrainFragment}
`;

export const outputResultDataFragment = gql`
  fragment outputResultDataFragment on outputResultData {
    data {
      name
      column {
        detail
        standard
      }
      split
      value {
        condition
        condition_min
        condition_max
        grainRequire_min
        grainRequire_max
        grainRequire
        isGrainPass
        key
        isInput
        maxLength
        minLength
        name
        percentage
        typeUnit
        unit
        id
        unitID
        value
        optionInput {
          type
          min
          max
          length
          decimal
        }
      }
    }
    isPass
    sumWeight
    totalGrain
    chalkyLevel
    yellowLevel
    undermilledLevel
    damagedLevel
    headLevel
    colorYellow
    colorChalky
    isAutoYellow
    createResultAt
  }
`;

export const TypeImageColorFragment = gql`
  fragment TypeImageColorFragment on TypeImageColor {
    type
    shape
  }
`;

export const packageFragment = gql`
  fragment packageFragment on package {
    type
    status
    startDate
    name
    maxUsage
    label
    isLimitReached
    isBeforeExpired
    expiredDate
    currentUsage
    billingCycleDate
  }
`;

export const UserAttributeFragment = gql`
  fragment UserAttribute on UserAttribute {
    email
    name
    phoneNumber
    signature
  }
`;

export const UserRoleFragment = gql`
  fragment UserRoleFragment on UserRole {
    permission {
      feature
      action
    }
    organization {
      permission {
        feature
        action
      }
    }
    updateDate
    updateBy
    roleName
    isAdmin
    id
  }
`;
